import { render, staticRenderFns } from "./ancestorsdetalis.vue?vue&type=template&id=53afc0e1&scoped=true"
import script from "./ancestorsdetalis.vue?vue&type=script&lang=js"
export * from "./ancestorsdetalis.vue?vue&type=script&lang=js"
import style0 from "./ancestorsdetalis.vue?vue&type=style&index=0&id=53afc0e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8c4e5e0a3a88c7932152ef02627e3518/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53afc0e1",
  null
  
)

export default component.exports